// src/ResultsGallery.js
import React from 'react';



const trackEvent = (eventName, photoId) => {
    // ESTE ES EL PRINT (Se ve en F12 -> Console)
    console.log(`GA4 Debug: Evento=${eventName} | ID Enviado=${photoId}`);
  
    if (window.gtag) {
      window.gtag('event', eventName, {
        'photo_id': photoId,
        'event_category': 'Interaccion_Foto'
      });
    } else {
      console.warn("GA4: window.gtag no detectado");
    }
  };


// Este componente recibe la información a través de las 'props' (propiedades),
// que son los datos que le envía el componente padre (App.js).
function ResultsGallery({ results, s3Host }) {
    // 1. Manejo de estado vacío: Si no hay resultados, muestra un mensaje.
    if (!results || results.length === 0) {
        return <div className="results-info">No se encontraron resultados.</div>;
    }

    // 2. Lógica para agrupar fotos únicas: Usamos el mismo método de tu HTML anterior.
    const uniquePhotos = {};
    results.forEach(item => {
        const s3_path = item.s3_path;

        if (!uniquePhotos[s3_path]) {
            uniquePhotos[s3_path] = {
                s3_path: s3_path,
                data_types: []
            };
        }
        const detectedInfo = item.detected_text || (item.data_type === 'FaceId' ? 'Coincidencia Facial' : 'Información no disponible');
        uniquePhotos[s3_path].data_types.push(`${item.data_type || ''}: ${detectedInfo}`);
    });

    // 👈 ELIMINAMOS la definición del componente DownloadButton, lo integramos directo.

    // 3. Renderizado (JSX): El código de aquí es HTML con superpoderes de JavaScript.
    return (
        <div id="results-gallery-container" className="gallery-container">
            <h3>Hemos encontrado:</h3>
            <h2>{Object.keys(uniquePhotos).length} foto(s)</h2>

            <div className="photos-grid">
                {/* Usamos .map() para iterar sobre la lista de fotos y generar un <div> por cada una. */}

{Object.values(uniquePhotos).map((photo) => {
    // 1. Esta es la URL que se ve en la galería (puedes dejarla como está)
    const fullUrl = `${s3Host}/${photo.s3_path}`;

    // 2. CREAMOS LA RUTA AL ORIGINAL: 
    // Reemplazamos 'watermarked/' por 'original/' en la cadena de texto
    const originalPath = photo.s3_path.replace('watermarked/', 'original/');
    const originalUrl = `${s3Host}/${originalPath}`;

    return (
        <div key={photo.s3_path} className="photo-item">

            {/* La imagen de la galería sigue usando fullUrl (la vista previa) */}
            <a rel="noopener noreferrer">
                <img src={fullUrl} alt="Foto del evento" className="photo-image" />
            </a>
           
            <div className='botones'>
                {/* CAMBIO AQUÍ: El enlace de descarga ahora usa originalUrl */}
                <a
                    href={originalUrl} // 👈 Cambiado a la carpeta original
                    target="_blank" 
                    rel="noopener noreferrer" 
                    className="download-icon"
                    title="Descargar foto original sin marca de agua"
                    onClick={() => trackEvent('imagen_descargada_regalo', originalPath)} 
                >
                    <i className="fa-solid fa-cloud-arrow-down"></i>
                </a>

                {/* CAMBIO AQUÍ: El enlace de WhatsApp ahora comparte la originalUrl */}
                <a
                    href={`https://wa.me/?text=${encodeURIComponent(`¡Mira mi foto de Fotorun! Descárgala sin marca aquí: ${originalUrl}`)}`}
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="whatsapp-icon"
                    title="Compartir original por WhatsApp"
                    onClick={() => trackEvent('imagen_compartida_regalo', originalPath)}
                >
                    <i className="fab fa-whatsapp"></i>
                </a>
            </div>
        </div>
    );
})}

            </div>
        </div>
    );
}

export default ResultsGallery; // Exportamos la función para poder usarla en App.js